export default __webpack_public_path__ + "static/media/7.c9d7edab.png";